import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/admin/tracks/:id");
export const getIndexPath = returnPath("/admin/tracks");
